// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"952":"7a549da4","5565":"391ac763"}[chunkId] + ".chunk.css";
};